import { render, staticRenderFns } from "./mongolianLang.vue?vue&type=template&id=115e711a&scoped=true&"
import script from "./mongolianLang.vue?vue&type=script&lang=js&"
export * from "./mongolianLang.vue?vue&type=script&lang=js&"
import style0 from "./mongolianLang.vue?vue&type=style&index=0&id=115e711a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e711a",
  null
  
)

export default component.exports